export const WA_PHONE = '5545988068508';
export const waLink = (text) => `https://wa.me/${WA_PHONE}?text=${encodeURIComponent(text)}`;
export const WA_GENERAL = waLink('Olá, Anderson! Vim pelo seu site e quero conversar sobre a minha marca.');

export const SEGMENTS = [
  'Hotelaria & Resorts',
  'Jornalismo & Mídia',
  'Turismo',
  'Gastronomia',
  'Profissionais liberais',
  'Eventos',
  'Empresas regionais',
];

export const scrollToId = (id) => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
